import { render, staticRenderFns } from "./ServizioPeriodicoDatiServizio.vue?vue&type=template&id=db714b86&"
import script from "./ServizioPeriodicoDatiServizio.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoDatiServizio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports